import { render, staticRenderFns } from "./ReviewRegisterErc20.vue?vue&type=template&id=5060ef30&scoped=true"
import script from "./ReviewRegisterErc20.vue?vue&type=script&lang=js"
export * from "./ReviewRegisterErc20.vue?vue&type=script&lang=js"
import style0 from "./ReviewRegisterErc20.vue?vue&type=style&index=0&id=5060ef30&prod&lang=scss&scoped=true"
import style1 from "./ReviewRegisterErc20.vue?vue&type=style&index=1&id=5060ef30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5060ef30",
  null
  
)

export default component.exports